export let productCenterSiLViewEN = {
  title: {
    h1: "On Cloud Computing Platform for Precise \nSimulation PD Cloud SiL",
    h2: "Precise simulation on the cloud",
    h3: "Introduction",
    h4: "Composition",
    h5: "Advantages",
  },
  section: {
    section0: {
      h1: "On Cloud Cloud Computing Platform for Precise Simulation",
      h2: "PD Cloud SiL is a cloud-based Software-in-the-Loop (SiL) simulation platform that can leverage the cloud computing power for multi-node parallel computing to improve the iteration speed of SiL simulation-based verification and validation.",
      SiLVideo: require("@/static/img/SiLVideo_en.mp4"),
    },
    section1: {
      h1: "Composition",
      section1Arr: [
        {
          h2: "Project",
          h3: "Users can create customized projects, each containing a project description and ",
          h4: "statistical data for quick comprehension of project context and test results.",
        },
        {
          h2: "Library",
          h3: "The cloud database allows the import and creation of sensors, the configuration of sensor ",
          h4: "parameters, the setting of ego vehicle parameters and browsing of scenario library.",
        },
        {
          h2: "Test",
          h3: "Configure test cases by specifying the target control algorithm's path, selecting",
          h4: " parameter configurations from the database, and generalizing test scenarios.",
        },
        {
          h2: "Run",
          h3: "Intuitive dashboards visually present test case execution status and results. ",
          h4: "Users can click any variant of generalized combinations within a 3D generalization ",
          h5: "matrix to inspect corresponding test outcomes.",
        },
      ],
    },
    section2: {
      h1: "Advantages",
      section2Arr: [
        {
          h1: "Cloud-based Parallel Computing",
          h2: "Significantly improves simulation validation iteration",
        },
        {
          h1: "Multi-tenancy Possibilities, Multi-user Access",
          h2: "Facilitate team collaboration",
        },
        {
          h1: "Hybrid Edge-cloud Deployment",
          h2: "Simulations run on the cloud while planning/control algorithms execute locally, ensuring user data security.",
        },
        {
          h1: "Variety of Generalization Methods",
          h2: "Gradient descent-based methods facilitate corner case detection.",
        },
        {
          h1: "Infinite Scenario Operation",
          h2: "Supports both predefined scenarios and infinite random testing via recursive layered parameter iteration, enhancing corner case coverage.",
        },
      ],
    },
  },
};
export let productCenterSiLViewCN = {
  title: {
    h1: "On Cloud 精准仿真云计算平台",
    h2: "云上的精准仿真世界",
    h3: "产品介绍",
    h4: "产品构成",
    h5: "产品优势",
  },
  section: {
    section0: {
      h1: "On Cloud 精准仿真云计算平台",
      h2: "是一款基于云的软件在环仿真平台，可充分利用云端算力进行多节点并行计算，以提高SiL仿真验证的迭代速率。",
      SiLVideo: require("@/static/img/SiLVideo.mp4"),
    },
    section1: {
      h1: "产品构成",
      section1Arr: [
        {
          h2: "Project",
          h3: "用户可以根据自己的需求创建项目。每个项目包含项目介绍",
          h4: "和统计数据，方便了解项目的背景、测试结果。",
        },
        {
          h2: "Library",
          h3: "云端数据库，可导入、创建传感器，配置传感器的参数，为主",
          h4: "车配置参数以及浏览配置场景库。",
        },
        {
          h2: "Test",
          h3: "设置测试用例，包括指定被测规控算法的路径、从数据库里",
          h4: "选择参数配置以及场景的泛化。",
        },
        {
          h2: "Run",
          h3: "直观便捷的图表显示测试用例运行状态及结果。",
          h4: "点击三维泛化矩阵图某个泛化组合查看相应的",
          h5: "测试结果。",
        },
      ],
    },
    section2: {
      h1: "产品优势",
      section2Arr: [
        {
          h1: "云端并行计算",
          h2: "可显著提高仿真验证的迭代速率",
        },
        {
          h1: "多租户、用户访问",
          h2: "使团队协作变得便捷",
        },
        {
          h1: "两地部署",
          h2: "仿真程序运行于云端，用户规划控制算法可运行于本地，以此保证用户本地数据安全",
        },
        {
          h1: "多种泛化方法",
          h2: "如基于梯度下降的方法，更易于寻找边缘场景",
        },
        {
          h1: "无限场景运行",
          h2: "不仅支持给定场景的测试，也支持基于分层场景元素参数递归式迭代的无限随机场景测试，有助于提高边缘场景的覆盖度",
        },
      ],
    },
  },
};
